module.exports = __webpack_public_path__ + "img/promote-wellness-depth1.ff6c003a.webp";